import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Skeleton from "@mui/material/Skeleton";
import CardContent from "@mui/material/CardContent";
import { Link as RouterLink } from "react-router-dom";
import { ListItemIcon } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { routes } from "../../routes/equities-routes";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  MemoryRouter,
  Route,
  Routes,
  Link,
  matchPath,
  useLocation,
} from "react-router-dom";
import { getDoc, doc } from "firebase/firestore";
import { db } from "../../firebase-config";
import { useParams } from "react-router-dom";

function useRouteMatch(patterns) {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
}

function MyTabs() {
  // You need to provide the routes in descendant order.
  // This means that if you have nested routes like:
  // users, users/new, users/edit.
  // Then the order should be ['users/add', 'users/edit', 'users'].
  const routeMatch = useRouteMatch(["/inbox/:id", "/drafts", "/trash"]);
  const currentTab = routeMatch?.pattern?.path;

  return (
    <Tabs value={currentTab}>
      <Tab label="Inbox" value="/inbox/:id" to="/inbox/1" component={Link} />
      <Tab label="Drafts" value="/drafts" to="/drafts" component={Link} />
      <Tab label="Trash" value="/trash" to="/trash" component={Link} />
    </Tabs>
  );
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

function NavTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        // variant="scrollable"
        // scrollButtons="auto"
        aria-label="scrollable auto tabs"
        centered
      >
        <Tab label="Overview" value={0} to="overview" component={Link} />
        <Tab label="Financials" value={1} to="financials" component={Link} />
        <Tab label="Key People" value={2} to="key-people" component={Link} />
        <Tab
          label="Financial Analysis"
          value={3}
          to="financial-analysis"
          component={Link}
        />
      </Tabs>
    </Box>
  );
}

function ListItemLink(props) {
  const { primary, to, description } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef(function Link(itemProps, ref) {
        return <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />;
      }),
    [to]
  );

  return (
    <>
      <Card>
        <CardContent>
          <li>
            <ListItem button component={renderLink}>
              <ListItemText primary={primary} />
              <ListItemIcon>
                <ArrowForwardRoundedIcon />
              </ListItemIcon>
            </ListItem>
          </li>
          <Typography>{description}</Typography>
        </CardContent>
      </Card>
    </>
  );
}

export default function CompanyNavigationMenu() {

  const [data, setData] = React.useState({});
  const [loading, setLoading] = React.useState(true);
  let params = useParams();
  const id = params.companyId;

  const list = Array.from({ length: 16 }, (v, k) => k + 1);


  React.useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const docRef = doc(db, "companies", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setData(docSnap.data());
        setLoading(false);
      } else {
        setData({});
        setLoading(false);
      }
    }
    // Fetch company overview
    fetchData();
  }, [id]);

  return loading ? <Box>
    <Box sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    }}>
      <Typography variant="h4" align="center" justifyContent={"center"}>
        <Skeleton width={300} sx={{ bgcolor: "white", }} />
      </Typography>
    </Box>
    <Box sx={{
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    }}>
      <Typography variant="h6" align="center" justifyContent={"center"}>
        <Skeleton width={300} sx={{ bgcolor: "white", }} />
      </Typography>
    </Box>
    <Grid container spacing={2}>
      {list.map((index) => {
        return (
          <Grid item xs={12} md={6} key={index}>
            <Card>
              <CardContent>
                <Typography variant="h6">
                  <Skeleton width="50%" sx={{ bgcolor: "white" }} />
                </Typography>
                <Typography variant="subtitle2">
                  <Skeleton sx={{ bgcolor: "white" }} />
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  </Box> : (
    <Box>
      {/* <NavTabs /> */}
      <Box>
        {data["name"] === undefined ? (
          <></>
        ) : (
          <Box sx={{
            mb: 1
          }}>
            <Typography variant="h4" align="center">
              {data["name"].length === 0 ? "-" : data["name"]}
            </Typography>
          </Box>
        )}
        {data["sector"] === undefined ? (
          <></>
        ) : (
          <Typography variant="h6" align="center">
            Sector: {data["sector"].length === 0 ? "-" : data["sector"]}
          </Typography>
        )}
      </Box>
      {Object.keys(data).length === 0 ? (
        <Typography variant="h4" align="center">Company Not Found :(</Typography>
      ) :
        <List dense={false}>
          <Grid container spacing={2}>
            {routes.map((route) => {
              return (
                <Grid item xs={12} md={6}>
                  <ListItemLink
                    primary={route.name}
                    to={`${route.route_name}`}
                    description={route.description}
                  />
                </Grid>
              );
            })}
          </Grid>
        </List>
      }
    </Box>
  );
}
